import { BaseModel } from '../../models/base.model';

export class ValidateEmailLinkRequest extends BaseModel<ValidateEmailLinkRequest> {

    code: string;
    token: string;

    constructor(properties?: Partial<ValidateEmailLinkRequest>) {
        super({
            code: undefined,
            token: undefined
        }, properties);
    }
}
